<template>
	<div class="page-container">
		<md-dialog-alert
		:md-active.sync="alert"
		:md-content="msgAlert"
		md-confirm-text="Ok" />
		<md-app md-mode="fixed">
			<md-app-toolbar class="md-primary">
				<md-button class="md-icon-button" @click="backHome()">
					<md-icon>arrow_back</md-icon>
				</md-button>
				<span class="md-title" style="font-size: 15px; font-weight: bold;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;max-width: 240px; margin-left: 0;">
					Extrato
				</span>
			</md-app-toolbar>
			<md-app-content>
				<div class="fundo-geral" style="height: 100%;">
					<div class="columns is-mobile is-centered mt-2">
						<div class="column is-11">
							<div class="card">
								<div class="card-content">
									<div class="columns is-mobile">
										<div class="column">
											<div class="field">
												<label class="label">Data Inicial</label>
												<div class="control has-icons-left">
													<input class="input" type="text" placeholder="Data Inicial" v-model="de" v-mask="'##/##/####'">
													<span class="icon is-small is-left">
														<i class="fa-solid fa-calendar-days"></i>
													</span>
												</div>
											</div>
										</div>
										<div class="column">
											<div class="field">
												<label class="label">Data Final</label>
												<div class="control has-icons-left">
													<input class="input" type="text" placeholder="Data Final" v-model="ate" v-mask="'##/##/####'">
													<span class="icon is-small is-left">
														<i class="fa-solid fa-calendar-days"></i>
													</span>
												</div>
											</div>
										</div>
									</div>
									<div class="columns is-mobile is-centered">
										<div class="column">
											<button class="button is-fullwidth is-link" v-bind:class="loadingClass()" @click="filterStatement()">Filtrar</button>
										</div>
									</div>
									<div>
										<div class="columns is-centered is-mobile">
											<div class="column">
												<table class="table is-hoverable is-striped is-fullwidth">
													<thead>
														<tr>
															<!-- <th>Tipo</th> -->
															<th>Valor</th>
															<th>Data</th>
															<th>St.</th>
															<th>Obs</th>
														</tr>
													</thead>
													<tbody>
														<tr v-if="statement.length == 0">
															<td colspan="5">{{ msgNotFound }}</td>
														</tr>
														<tr v-if="statement.length > 0" v-for="st in statement">
															<!-- <td>{{ st.type }}</td> -->
															<td v-bind:class="typeClass(st.type)"> <span v-if="st.type == 'w'" class="mr-1">-</span>{{ formataValor(st.value) }}</td>
															<td>{{ st.date }}</td>
															<td>
																<span class="icon">
																	<i class="fa-solid fa-check has-text-success" v-if="st.status == 'p'" title="Confirmado"></i>
																	<i class="fa-solid fa-rectangle-xmark has-text-danger" v-if="st.status == 'c'" title="Cancelado"></i>
																	<i class="fa-solid fa-clock has-text-warning" v-if="st.status == 'w'" title="Aguardando"></i>
																</span>
															</td>
															<td>
																<span class="icon">
																	<i class="fa-solid fa-eye" @click="visualizarObs(st.description)"></i>
																</span>
															</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</md-app-content>
		</md-app>
	</div>
</template>
<script>

	import axios from 'axios'

	export default {
		name: 'TitanClientStatement',
		components: {},
		data () {
			return {
				alert: false,
				msgAlert: '',
				loadingForm: false,
				statement: [],
				de: '',
				ate: '',
				msgNotFound: 'Selecione o período e clique em filtrar'
			}
		},
		methods: {
			backHome: function() {
				this.$router.push({ name: 'TitanClient'})
			},
			loadingClass: function() {
				return {
					'is-loading': (this.loadingForm == true)
				}
			},
			typeClass: function(type) {
				return {
					'has-text-danger': (type == 'w'),
					'has-text-success': (type == 'd')
				}
			},
			formataValor: function(valor) {
				return parseFloat(valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
			},
			visualizarObs: function(msg) {
				this.msgAlert = msg
				this.alert = true
			},
			convertToDate: function(dateString) {
				var dateParts = dateString.split("/");
				return new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
			},
			filterStatement: function() {
				if (this.cliente) {
					this.loadingForm = true;

					var de = moment(this.convertToDate(this.de))
					var ate = moment(this.convertToDate(this.ate))

	        		if (!(de.isValid()) || !(ate.isValid())) {
	        			this.msgAlert = "Período inválido."
	        			this.alert = true
	        			this.loadingForm = false;
	        			return false;
	        		}

					var config = {
						headers: {Authorization: 'Bearer  ' + this.$store.state.cliente.token}
					};

					axios
					.get(this.$root.$data.API_URL + 'client/statement/' + de.format("YYYY-MM-DD") + "/" + ate.format("YYYY-MM-DD"), config)
					.then(response => {
						let result = response.data
						if (result.success) {
							this.statement = result.statement
							if (this.statement.length == 0) this.msgNotFound = 'Nenhum registro encontrado'
						}
						else {
							this.alert = true
							this.msgAlert = result.message
						}
					}).finally(() => this.loadingForm = false);
				}
				else {
					this.alert = true;
					this.msgAlert = 'Ocorreu um problema com seu login, por favor recarregue a página.';
				}
			}
		},
		created() {
			if (!this.cliente) this.backHome();
		},
		mounted() {
			this.de = '28/02/2023';
			this.ate = '28/02/2023';
		},
		computed: {
			cliente: function () {
				return this.$store.state.cliente
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import "~vue-material/dist/theme/engine"; // Import the theme engine

	@include md-register-theme("default", (
		primary: #000000, // The primary color of your brand
		accent: #CB1323 // The secondary color of your brand
		));

	@import "~vue-material/dist/theme/all"; // Apply the theme

	.md-app-scroller {
		overflow: unset;
	}

</style>


// WEBPACK FOOTER //
// src/components/TitanClientStatement.vue